import { all, fork } from 'redux-saga/effects';
import { watchAuth } from './auth';
import { watchPods } from './pods';
import { watchSkus } from './skus';
import { watchCart } from './cart';
import { watchPayment } from './payment';
import { watchUser } from './user';
import { watchOrders } from './orders';
import { watchPassbook } from './passbook';
import { watchFeedback } from './feedback';
import { watchWallet } from './wallet';
import { watchLogger, watchLog } from './log';
import { watchVirtualShelf } from './virtual-shelf';
import { watchRating } from './rating';
import { watchDelivery } from './delivery';
import { watchApp } from './app';

export default function* rootSaga() {
	yield all([
		watchAuth(),
		watchPods(),
		watchSkus(),
		watchCart(),
		watchPayment(),
		watchUser(),
		watchOrders(),
		watchPassbook(),
		watchFeedback(),
		watchWallet(),
		watchVirtualShelf(),
		watchRating(),
		watchDelivery(),
		watchLog(),
		watchApp(),
		yield fork(watchLogger),
	]);
}
